// config.js

export const ENDPOINT_BASE_URL = 'https://max1-funding-arb.uc.r.appspot.com';
export const USDI_API_URL = 'https://usdi-api-jlukzyz7wa-ew.a.run.app/';
/** Same deployment family as cash_redeem, record_email_uid_txs_requests, etc. See API handout. */
export const USDI_API_EUROPE_WEST_URL = 'https://usdi-api-256611876551.europe-west1.run.app';
/** Admin notifications for C2C / large-amount manual ops (POST JSON). Override with REACT_APP_ADMIN_C2C_WEBHOOK_URL if needed. */
export const ADMIN_C2C_WEBHOOK_URL = `${USDI_API_EUROPE_WEST_URL}/admin/c2c_webhook`;
export const DISTRIBUTION_API_URL  = 'https://distribution-calculator-256611876551.europe-west1.run.app';

export const RPC_URL = 'https://solitary-boldest-thunder.solana-mainnet.quiknode.pro/7e14722814e9fc29ad81532c2da66c2ffbe3781f';
// const RPC_URL = "https://rpc.ankr.com/solana/80465c767c6a5751c4cadf0778b6917d26c2d0a9ae583d3616ffaae71191a7c4";

/** QA wallets: lower large-amount threshold and allow redeem UI without USDi balance. */
export const QA_TESTING_WALLETS = [
  'EyURfpwn8Bs1nz8QcBnGTAWZBfyX3w6qbqe3mXKDG4vR',
  '7xZMMKjZtonV5QEBTcUZ23R3Ut7zyn4tgyfhPCVQbeLL',
  'C5J81AX8S9hnZkfiupsWPjisD2zZh8DzP4tmUkHmTXRX',
  '5hQ3N9hUsppSDi8rxiixaUqvjScdgPfPNFnMS4Uaz5Zb',
  '5rqstBdnRSYwJg1F6GdFhWxqejTgVSfbuDxkECNtt3QN',
];

export function isQaTestingWallet(walletAddress) {
  const addr = typeof walletAddress === 'string' ? walletAddress.trim() : '';
  return addr.length > 0 && QA_TESTING_WALLETS.includes(addr);
}

export const LARGE_AMOUNT =
  typeof window !== 'undefined' &&
  isQaTestingWallet(
    window.localStorage?.getItem('walletaddress') ??
      window.localStorage?.getItem('walletAddress')
  )
    ? 0.1
    : 11000;

/** QA wallets: skip UI min/max payment-amount checks for Zelle on USDi → cash (C2C) redeem. */
export const ZELLE_C2C_LIMIT_EXCEPTION_WALLETS = [
  'Ao2obM4p8ky6umvkYSHBuXJzqYAQtNRzGVG5G4EMFV7K',
  'C5J81AX8S9hnZkfiupsWPjisD2zZh8DzP4tmUkHmTXRX',
];

export function shouldSkipZelleC2cPaymentAmountLimit(walletAddress, paymentMethodName) {
  const addr = typeof walletAddress === 'string' ? walletAddress.trim() : '';
  return (
    paymentMethodName === 'Zelle' &&
    addr.length > 0 &&
    ZELLE_C2C_LIMIT_EXCEPTION_WALLETS.includes(addr)
  );
}

export function shouldSkipC2cPaymentAmountLimit(walletAddress, paymentMethodName) {
  if (shouldSkipZelleC2cPaymentAmountLimit(walletAddress, paymentMethodName)) {
    return true;
  }

  return paymentMethodName === 'Venmo' && isQaTestingWallet(walletAddress);
}

let configCache = {
  squadsPublicKey: '',
  usdiTokenAddress: '',
  usdtTokenAddress: '',
  usdcTokenAddress: '',
  kraTokenAddress: '',
  c2c_redeem_network_fee_percentage: '',
  c2c_squad_receiving_address:'',
  isFetched: false, // We'll rely on this to see if we need to fetch
};

// This function does the actual fetching:
async function initConfig() {
  try {
    // 1) Fetch squads public key
    {
      const res = await fetch(
        'https://usdi-api-256611876551.europe-west1.run.app/usdi_squads_public_key'
      );
      if (!res.ok) throw new Error('Failed to fetch squads public key');
      const data = await res.json();
      if (data && data.USDi_Squads_Public_Key) {
        configCache.squadsPublicKey = data.USDi_Squads_Public_Key;
      }
    }

    // 2) Fetch all Solana token addresses
    {
      const res = await fetch(
        'https://usdi-api-256611876551.europe-west1.run.app/verified_solana_token_mint_address'
      );
      if (!res.ok) throw new Error('Failed to fetch verified_solana_token_mint_address');
      const data = await res.json();
      // e.g.
      // {
      //   "verified_token_solana_usdi": "...",
      //   "verified_token_solana_usdt": "...",
      //   "verified_token_solana_usdc": "...",
      //   "verified_token_solana_kra": "..."
      // }
      if (data) {
        if (data.verified_token_solana_usdi) {
          configCache.usdiTokenAddress = data.verified_token_solana_usdi;
        }
        if (data.verified_token_solana_usdt) {
          configCache.usdtTokenAddress = data.verified_token_solana_usdt;
        }
        if (data.verified_token_solana_usdc) {
          configCache.usdcTokenAddress = data.verified_token_solana_usdc;
        }
        if (data.verified_token_solana_kra) {
          configCache.kraTokenAddress = data.verified_token_solana_kra;
        }
      }
    }

    // 3) Fetch c2c_redeem_config_solana
    {
      const res = await fetch(
        'https://usdi-api-256611876551.europe-west1.run.app/c2c_redeem_config_solana'
      );
      if (!res.ok) throw new Error('Failed to fetch c2c_redeem_config_solana');
      const data = await res.json();
      if (data && data.network_fee_percentage) {
        configCache.c2c_redeem_network_fee_percentage = data.network_fee_percentage;
      }
    }
  {
      const response = await fetch("https://usdi-api-256611876551.europe-west1.run.app/cash_redeem/get_c2c_receiving_address", {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},

        });
        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }
        const data = await response.json();
         if (data && data.c2c_usdi_receiving_squads_address) {
        configCache.c2c_squad_receiving_address = data.c2c_usdi_receiving_squads_address;
      }
    }
    // Mark as fetched after everything is successful
    configCache.isFetched = true;

  } catch (error) {
    console.error('Error fetching config:', error);
    throw error;
  }
}

/**
 * getConfig: Lazy-loads the config if it hasn't been fetched yet.
 */
export async function getConfig() {
  // If we haven't fetched yet, do so now
  if (!configCache.isFetched) {
    await initConfig();
  }

  // Return a snapshot of the config
  return {
    squadsPublicKey: configCache.squadsPublicKey,
    usdiTokenAddress: configCache.usdiTokenAddress,
    usdtTokenAddress: configCache.usdtTokenAddress,
    usdcTokenAddress: configCache.usdcTokenAddress,
    kraTokenAddress: configCache.kraTokenAddress,
    c2c_redeem_network_fee_percentage:
      configCache.c2c_redeem_network_fee_percentage,
    c2c_squad_receiving_address: configCache.c2c_squad_receiving_address,
  };
}

export const VIP_LEVELS = ["General Member", "Silver VIP", "Gold VIP", "Sapphire VIP"];


export function getNextTier(currentTier) {
  const idx = VIP_LEVELS.indexOf(currentTier);
  if (idx < 0 || idx === VIP_LEVELS.length - 1) {
    return null; // 已是最高档或无法识别
  }
  return VIP_LEVELS[idx + 1];
}

/**
 * 2) 返回某档 VIP 所需的最低 KRA
 */
export function getRequiredKraForTier(tier) {
  switch (tier) {
    case "Silver VIP":
      return 100000;
    case "Gold VIP":
    case "Sapphire VIP":
      return 200000;
    default:
      return 0; // 其它档（如 General Member）
  }
}


export function getTierBenefits(tier) {
  const allBenefits = {
    usdiYield: true,
    c2cFiatOffRamps: true,
    kiraAi: false,
    mintWithWire: false,
    c2cOperator: false,
    exclusivePerks: false,
  };


  switch (tier) {
    case 'Silver VIP':
      allBenefits.kiraAi = true;
      break;
    case 'Gold VIP':
      allBenefits.kiraAi = true;
      allBenefits.mintWithWire = true;
      break;
    case 'Sapphire VIP':
      allBenefits.kiraAi = true;
      allBenefits.mintWithWire = true;
      allBenefits.c2cOperator = true;
      allBenefits.exclusivePerks = true;
      break;
    default:
      break;
  }
  return allBenefits;
}
